import styled from "styled-components";

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 72px 0 48px 0;
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    margin: 60px 0;
  }
  button {
    margin-left: 20px;
  }
`;
